import * as React from 'react';
import LazyLoad from 'react-lazyload';
type Props = {
  className?: string;
  height?: number;
};

const AppBadges = ({ className, height = 48 }: Props) => (
  <div className={className}>
    <a target="_blank" rel="noopener noreferrer" href="https://app.adjust.com/5pm3gw">
      <LazyLoad once>
        <img
          src={require('../../../assets/logos/store-apple.svg')}
          alt="Play Store"
          className="mr-sm-12"
          style={{
            height,
          }}
        />
      </LazyLoad>
    </a>
    <a target="_blank" rel="noopener noreferrer" href="https://app.adjust.com/coc7or">
      <LazyLoad once>
        <img
          src={require('../../../assets/logos/store-google.svg')}
          alt="App Store"
          style={{
            height,
          }}
        />
      </LazyLoad>
    </a>
  </div>
);

export default AppBadges;
